import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { api, type Me } from './api';

/** Încarcă date de la API; `reload()` le reîmprospătează. */
export function useData<T>(url: string | null) {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const load = useCallback(() => {
    if (!url) return;
    setLoading(true);
    api.get<T>(url)
      .then((d) => { setData(d); setError(null); })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [url]);
  useEffect(load, [load]);
  return { data, error, loading, reload: load };
}

export const MeContext = createContext<Me | null>(null);
export const useMe = () => useContext(MeContext)!;
export const can = (me: Me, ...perms: string[]) => perms.some((p) => me.systemPermissions.includes(p));
